module.exports = __webpack_public_path__ + "static/media/home2icons4.16f5e407.svg";